import { Form } from 'formik';
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 370px;
    margin-top: 85px;

    h1 {
      color: ${({ theme }) => theme.colors.blue};
      font-size: 1.4375rem;
      font-weight: bold;
      text-align: left;
      line-height: 18px;
      margin-bottom: 12px;
    }

    h2 {
      color: #5E5E5E;
      font-size: 0.9375rem;
      text-align: left;
      line-height: 26px;
      margin-bottom: 22px;
    }

    a {
      text-decoration: none;
    }

    @media (max-width: 768px) {
      margin-top: 24px;
      min-height: calc(100vh - 356px);
    }
`;

export const Label = styled.span`
  color: #5E5E5E;
  svg {
    margin-left: -5px;
    margin-right: 4px;
  }
  margin-bottom: 22px;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const InputsContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;

  p {
    color: #5E5E5E;
    font-size: 0.9375rem;
    line-height: 26px;
    margin-bottom: 20px;
  }
`;


export const ButtonsContainer = styled.div`
  width: 100%;

  button {
    margin-bottom: 20px;
  }
`;



export const DaySection = styled.section`
  margin-bottom: 30px;

  h1 {
    font-size: 0.8125rem;
    font-weight: bold;
    margin: 0;
    margin-bottom: 15px;
    color: black;
  }

  input {
    display: none;
    height: 0;
    width: 0;
  }

  label {
    height: 40px;
    width: 40px;
    font-size: 0.9375rem;

    border-radius: 3px;
    border: 1px solid #9A9A9A;

    color: #9A9A9A;
    text-align: center;
    vertical-align: center;

    display: flex;
    place-content: center;
    place-items: center;

    margin: 0;
    margin-right: 10px;

    position: relative;

    div {
        height: 13.42px;
        width: 13.42px;
        position: absolute;
        background-color: #0ECE00;
        display: flex;
        place-content: center;
        place-items: center;
        border-radius: 100%;
        color: white;
        top: -6px;
        right: -6px;
        opacity: 0;
    }
  }

  div {
    display: flex;
  }

  input[type="radio"]:checked + label {
    color: white;
    border: 1px solid  ${({ theme }) => theme.colors.lightBlue};
    background-color: ${({ theme }) => theme.colors.lightBlue};

    div {
        opacity: 1;
    }
  }
`;


export const MailSection = styled.section`
  margin-bottom: 28px;

  h1 {
    font-size: 0.8125rem;
    font-weight: bold;
    margin: 0;
    margin-bottom: 15px;
    color: black;
  }

  div {
    display: flex;
    flex-direction: row;

    input {
      height: 14px;
      width: 14px;
    }

    input[type='radio']:after {
      height: 10px;
      width: 10px;
    }

    label {
      margin-left: 10px;
      margin-right: 29px;
      font-size: 0.8125rem;
      color: #4D565C;
      line-height: 16px;
      font-weight: 400;
    }
  }
`;

export const EmailSection = styled.section`
  margin-bottom: 30px;
`;

export const StyledField = styled.div`
  margin-bottom: 20px;
`;

export const AutomaticDebtSection = styled.section`
  h1 {
    font-size: 0.8125rem;
    font-weight: bold;
    margin: 0;
    margin-bottom: 15px;
    color: black;
  }

  p {
    font-size: 0.8125rem;
    color: black;
    max-width: 274px;
  }
`;

export const TermsSection = styled.section`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-top: 1rem;

  input {
    margin-right: 10px;
  }

  label {
    color: #7A7A7A;
    font-size: 0.875rem;
    line-height: 0.875rem;
    font-weight: 400;
  }

  a {
    cursor: pointer;
    font-size: 0.8125rem;
    font-weight: 700;
    text-decoration: none;
    color: #0B29FB !important;
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Error = styled.span`
  color: #dc3545;
`;


export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  button {
    width: 100%;
    max-width: 160px;
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 648px;
    width: auto;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  max-width: 470px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    place-content: space-between;

    h2 {
      margin: 0;
      color: #808495;
      font-size: 18px;
      font-weight: 400;
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
    cursor: pointer;
    margin-left: 10px;
  }

  margin-bottom: 16px;
`;

export const AutomaticDebtCheckMark = styled.div`
  display: flex;

  label {
    color: #7A7A7A;
    margin-left: 0.875rem;
    font-size: 0.875rem;
    margin-top: 0.1875rem;
  }
`

export const AutomaticDebtFormField = styled.fieldset`
  display: flex;
  flex-direction: column;

  label {
    margin-top: 1rem;
  }

  input {
    margin-top: 1rem;
  }
`;

export const WarningSection = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #e7e6e6;
  color: #000;
  padding: 5px;
  margin-bottom: 30px;
  border-left: 5px solid #aeabab;
  border-radius: 5px;

  span {
    font-weight: 600;
    font-size: 16px;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
`;

export const Alert = styled.div`
  border: 2px solid #000fff;
  padding: 10px 15px;
  border-radius: 10px;
  font-size: 14px;
  color: #000fff;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;

  p {
    font-size: 14px !important;
    color: #000fff !important;
    line-height: 1;
  }

  ul {
    padding-inline-start: 1rem;
  }
`;
